import { Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { FplIfpsOrm, ifpsOrmSummary } from "../models/flight";
import "../css/ifpsMessages.css";

interface IfpsMessagesListProps {
  ormHistory: FplIfpsOrm[];
  label?: string;
  // Top spacing is the caller's call: on the ops page the list follows body text and needs the gap, on
  // the pilot page it sits right under its own <h2> and the default reads as a separate section.
  className?: string;
}

// Newest-first list of the ORMs EUROCONTROL sent back for a filed FPL. Each row collapses to a one-line
// gist and expands to the raw ADEXP telegram. Shared by the ops FPL page and the pilot's /fly page so a
// message never reads differently depending on where it is opened.
function IfpsMessagesList({ ormHistory, label = "IFPS messages (raw)", className = "mt-3" }: IfpsMessagesListProps) {
  if (ormHistory.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <small className="text-muted">{label}</small>
      <div className="d-grid gap-2 mt-1">
        {ormHistory.slice().reverse().map((orm, i) => {
          const summary = ifpsOrmSummary(orm);
          return (
            <details key={i} className="border rounded p-2 bg-light ifps-orm">
              <summary className="small d-flex align-items-start" style={{ cursor: "pointer", gap: "0.4rem" }}>
                <FontAwesomeIcon icon={faCaretRight} className="ifps-orm-caret text-muted flex-shrink-0" style={{ marginTop: "0.2rem" }} />
                <span className="ifps-orm-summary">
                  <strong>{orm.type}</strong>
                  {orm.receivedAt && moment(orm.receivedAt).isValid() && (
                    <span className="text-muted"> · {moment(orm.receivedAt).utc().format("DD/MM HH:mm")}Z</span>
                  )}
                  {orm.isTest && <Badge bg="secondary" className="ms-2">TEST</Badge>}
                  {summary && <span className="text-muted"> — {summary}</span>}
                </span>
              </summary>
              {orm.raw ? (
                <pre className="font-monospace small mb-0 mt-2" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{orm.raw}</pre>
              ) : (
                <div className="text-muted small mt-2">No raw telegram stored for this message (only the most recent messages keep the full raw text).</div>
              )}
            </details>
          );
        })}
      </div>
    </div>
  );
}

export default IfpsMessagesList;
